import React from 'react';

export default function EmConstrucao() {
  return (
    <>
      <div>
        <h3>Página em construção</h3>
      </div>
    </>
  );
}
